import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "period" };
const _hoisted_3 = { class: "transactions" };
const _hoisted_4 = { key: 1 };
import Transaction from "@/components/uikit/platformComponents/transactions/Transaction.vue";
import UNoData from "@/components/uikit/uComponents/UNoData.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionsList',
    props: {
        transactions: {},
        invesrtSigns: { type: Boolean },
        isInvestmentHistory: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (__props.transactions?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.transactions, (group, groupIndex) => {
                        return (_openBlock(), _createElementBlock("div", { key: groupIndex }, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(group.date), 1),
                            _createElementVNode("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.transactions, (transaction, index) => {
                                    return (_openBlock(), _createBlock(Transaction, {
                                        key: index,
                                        name: transaction.name,
                                        "transaction-type": transaction.type,
                                        amount: transaction.amount,
                                        "is-refill": transaction.isRefill,
                                        "invesrt-signs": __props.invesrtSigns,
                                        "card-type": transaction.cardType,
                                        decimals: transaction.decimals,
                                        indent: transaction?.indent,
                                        mnemonic: transaction.mnemonic,
                                        "is-confirmed": transaction.isConfirmed,
                                        hash: transaction.hash,
                                        "address-eth": transaction.addressEth,
                                        "address-from": transaction.addressFrom,
                                        "address-to": transaction.addressTo,
                                        icon: transaction.icon,
                                        "is-owner-transaction": transaction.isOwnerTransaction,
                                        "project-id": transaction.projectId,
                                        "project-name": transaction.projectName,
                                        "is-voting": transaction.isVoting,
                                        "is-investment-history": true
                                    }, null, 8, ["name", "transaction-type", "amount", "is-refill", "invesrt-signs", "card-type", "decimals", "indent", "mnemonic", "is-confirmed", "hash", "address-eth", "address-from", "address-to", "icon", "is-owner-transaction", "project-id", "project-name", "is-voting"]));
                                }), 128))
                            ])
                        ]));
                    }), 128))
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(UNoData)
                ]));
        };
    }
});
